import type { LegalReacceptancePending } from '../conta/api.js';

type Choices = Record<string, 'accepted' | 'refused'>;
const keyFor = (id: string) => `nev-legal-return:${id}`;
const signature = (pending: LegalReacceptancePending) =>
  JSON.stringify(pending.documents.map((doc) => [doc.id, doc.version, doc.content_hash]));

/** Rascunho local de escolhas explícitas para retorno OAuth. Nunca contém senha/prova. */
export function guardarDecisoes(pending: LegalReacceptancePending, choices: Choices): boolean {
  try {
    sessionStorage.setItem(
      keyFor(pending.participation_id),
      JSON.stringify({
        expires: Date.now() + 15 * 60_000,
        signature: signature(pending),
        choices: Object.fromEntries(
          pending.documents.flatMap((doc) => {
            const decision = choices[doc.id];
            return decision === 'accepted' || decision === 'refused' ? [[doc.id, decision]] : [];
          }),
        ),
      }),
    );
    return true;
  } catch {
    return false;
  }
}

export function retomarDecisoes(pending: LegalReacceptancePending): Choices {
  try {
    const key = keyFor(pending.participation_id);
    const raw = sessionStorage.getItem(key);
    if (!raw) return {};
    const value: unknown = JSON.parse(raw);
    if (typeof value !== 'object' || value === null) return {};
    const saved = value as { expires?: unknown; signature?: unknown; choices?: unknown };
    if (
      typeof saved.expires !== 'number' ||
      saved.expires < Date.now() ||
      saved.signature !== signature(pending) ||
      typeof saved.choices !== 'object' ||
      saved.choices === null
    ) {
      sessionStorage.removeItem(key);
      return {};
    }
    const choices = saved.choices as Record<string, unknown>;
    return Object.fromEntries(
      pending.documents.flatMap((doc) => {
        const decision = choices[doc.id];
        return decision === 'accepted' || decision === 'refused' ? [[doc.id, decision]] : [];
      }),
    ) as Choices;
  } catch {
    return {};
  }
}

export function limparDecisoes(participationId: string): void {
  try {
    sessionStorage.removeItem(keyFor(participationId));
  } catch {
    /* Armazenamento pode estar indisponível. */
  }
}
